import * as functions from './functions';

function allowMembershipSubmit() {
    var payment_type = jQuery('input[name="billing-payment_method"]:checked').val();
    if (payment_type == 'bankaccount') {

    } else if (payment_type == 'creditcard') {

    }
    return false;
}
(function($){

    var cc_valid = false;

    function allowSubmit() {

        var allow = false;
        var toc_checked = $('input#msTermsConditions').prop('checked');

        if ($('input[name="billing-payment_method"]:checked').val() === 'creditcard') {

            allow = cc_valid && toc_checked;

        } else if ($('input[name="billing-payment_method"]:checked').val() === 'bankaccount') {

            var name_on_account = $('#billing-name_on_account').val();
            var routing_number = $('#billing-routing_number').val();
            var account_number = $('#billing-account_number').val();
            var account_number_confirm = $('#billing-confirm_account_number').val();
            var account_type = $('input[name="billing-account_type"]:checked').val();

            var bankaccount_valid = (routing_number != '' && account_number != '' && account_number_confirm != '' && name_on_account != '') && (account_number === account_number_confirm) && account_type != null;
            
            allow = bankaccount_valid && toc_checked;

            if (bankaccount_valid) {
                if (typeof fbq === 'function') { fbq('track', 'AddPaymentInfo'); }
                functions.cy_dispatchEvent(document, 'added_valid_bank');
            }

        }

        if (toc_checked && !allow) {
            $('#membership-signup-payment-notice').text('Please check your payment info.').show();
        } else {
            $('#membership-signup-payment-notice').text('').hide();
        }

        $('button[form="membership-signup"]').toggleClass('disabled', !allow);

        if (allow) {
            functions.cy_dispatchEvent(document, 'completed_signup_requirements');
        }

    }

    $(document).on('ready', function(){
        
        if (typeof recurly === 'object' && $('#recurly-elements').length > 0) {
            
            recurly.configure(CY_VARS.env === 'dev' || CY_VARS.user_is_admin === "1" ? 'ewr1-u8N7ZhXjcVCZO6jysyPWfI' : 'ewr1-Ua6uFfFbcFxd8Rw3pcth54');

            var elements = recurly.Elements();
            var cardElement = elements.CardElement({
                style: {
                    fontFamily: 'Raleway',
                    fontSize: '16px',
                    fontColor: '#333',
                    fontWeight: '700',
                    textTransform: 'uppercase',
                    
                }
            });
            cardElement.attach('#recurly-elements');

            cardElement.on('change', function(state){

                cc_valid = state.valid;

                if ( cc_valid && (!state.cvv.focus && !state.expiry.focus && !state.number.focus) ) {

                    if (typeof fbq === 'function') { fbq('track', 'AddPaymentInfo'); }
                    functions.cy_dispatchEvent(document, 'added_valid_cc');

                }

                allowSubmit();

            });

        }

        $('#clearCoupon').on('click', (e) => { e.preventDefault(); clearCoupon(); });
        
        function clearCoupon() {
            $('#couponCode').val('');
            $('#couponResult, #clearCoupon').removeClass().hide();
            functions.removeDiscountsFromCart();
        }
        
        $('#applyCoupon').on('click', function(e){
            e.preventDefault();
            var couponCode = $('#couponCode').val();
            if (couponCode == '') {
                $('#couponResult').removeClass().addClass('alert alert-warning').text("Please enter a coupon code and try again.").show();
                return false;
            }
            checkCoupon();
        });

        function checkCoupon() {
            var couponCode = jQuery('#couponCode').val();
            $('#applyCoupon').addClass('loading');
            $('#couponCode').prop('disabled', true);
            $.ajax({
                method: 'POST',
                url: CY_VARS.ajaxurl,
                data: {
                    action: 'check_recurly_coupon',
                    code: couponCode,
                    cpn_nonce: jQuery('input[name="cpn_nonce"]').val(),
                    cart: functions.getCart()
                }
            }).success(function(res){

                var status = '';
                var message = res.message;

                functions.removeDiscountsFromCart();

                switch(res.result) {
                    case 'valid' :
                        status = 'success';
                        functions.getCart().discount = res;
                    break;
                    case 'expired' :
                        status = 'warning';
                    break;
                    case 'invalid' : 
                        status = 'danger';
                    break;
                    default :
                        status = 'warning';
                }

                $('#couponResult').removeClass().addClass('alert alert-'+status).text(message).show();
                $('#couponCode').prop('disabled', false);
                $('#clearCoupon').show();
                $('#applyCoupon').removeClass('loading').blur();

                functions.calculateCartTotals();

            });
        }

        $('input[name="billing-payment_method"]').on('change', function(){
            $('.payment-method-container').hide();
            $('.select-payment-method-container label').removeClass('active');
            $('input[name="billing-payment_method"]:checked').parent('label').addClass('active');
            $('#'+$('input[name="billing-payment_method"]:checked').val()+'-details').show();
            if (jQuery(window).outerHeight() <= 767) {
                $('body, html').animate({
                    scrollTop: $('#'+$('input[name="billing-payment_method"]:checked').val()+'-details').offset().top - $('#wrapper-navbar nav').outerHeight()
                }, 1000);
            }
            functions.cy_dispatchEvent(document, 'switched_pmt_method', {type:$('input[name="billing-payment_method"]:checked').val()});
        });

        $('#msTermsConditionsLink').on('click', function(e){
            e.preventDefault();
            $('#TermsAndConditions').modal();
        });

        $('input#msTermsConditions, input#billing-name_on_account, input#billing-routing_number, input#billing-account_number, input#billing-confirm_account_number').on('change', function(){
            allowSubmit();
        });

        $('input[name="hasReferral"]').on('change', function(){
            if( $('input#hasReferral').prop('checked') ) {
                $('#referralFields').collapse('show');
            } else {
                $('#referralFields').collapse('hide');
            }
        });

        // Set up input masks
        $('#msPhone').inputmask('(999) 999-9999', {autoUnmask: true});

        var now = new Date();
        var month = now.toLocaleString('default', {month: 'long'});
        var day = now.toLocaleString('default', {day: 'numeric'});
        var year = now.toLocaleString('default', {year: 'numeric'});
        var todays_date = month + ' ' + day + functions.nth(day) +  ' ' + year;
        var signup_form = document.querySelector('#membership-signup');
        $('.todays-date').text(todays_date);
        $('#billingDate').text(day + functions.nth(day));

        if (signup_form != null) {

            signup_form.addEventListener('submit', function(e){

                e.preventDefault();

                functions.cy_dispatchEvent(document, 'submit_signup_form');

                var form = this;
                var recaptcha_token = false;

                $('button[form="membership-signup"]').addClass('loading');
                $('#membership-signup-payment-error').text('').hide();

                // Recurly payment token handler
                function tokenHandler(err, token){ 
                    var $submitBtn = $('button[form="membership-signup"]');
                    if (err) {
                        console.log('Recurly token error:', err);
                        $('#membership-signup-payment-error').text('There was an issue with your payment method: ' + err.message).show();
                        $submitBtn.removeClass('loading');
                        functions.cy_dispatchEvent(document, 'recurly_token_err', err);
                    } else if (!recaptcha_token) {
                        $('#membership-signup-payment-error').text('Oops! Something went wrong. Please contact us if you continue to experience this issue.').show();
                        $submitBtn.removeClass('loading');
                        functions.cy_dispatchEvent(document, 'recaptcha_err');
                    } else {
                        $.ajax({
                            method: 'POST',
                            url: CY_VARS.ajaxurl,
                            data: {
                                action: 'new_recurly_client',
                                payment_token: token,
                                first_name: $('input[data-recurly="first_name"]').val(),
                                last_name: $('input[data-recurly="last_name"]').val(),
                                business_name: $('input[name="businessName"]').val(),
                                email: $('input[data-recurly="email"]').val(),
                                phone: $('input[data-recurly="phone"]').val(),
                                street1: $('input[data-recurly="address1"]').val(),
                                city: $('input[data-recurly="city"]').val(),
                                postal_code: $('input[data-recurly="postal_code"]').val(),
                                state: $('select[data-recurly="state"]').val(),
                                country: $('select[data-recurly="country"]').val(),
                                client_website: $('input[name="yourWebsiteURL"]').val(),
                                cart_items: functions.getCart().items,
                                monthly_total: functions.getCart().dueMonthly,
                                discount: functions.getCart().discount,
                                security: $('input[name="checkout_nonce"]').val(),
                                recaptcha_token: recaptcha_token,
                                recaptcha_action: 'purchase'
                            }
                        }).success(function(payment_response){
                            
                            if (payment_response.result === 'success') {
                                if ( typeof fbq === 'function' ) {
                                    var fb_due_monthly = functions.getCart().dueMonthly;
                                    var fb_total = fb_due_monthly + functions.getCart().dueToday;
                                    fbq('track', 'Purchase', {value: fb_total, currency: 'USD'});
                                    fbq('track', 'Subscribe', {value: fb_due_monthly, currency: 'USD'});
                                }
                                functions.cy_dispatchEvent(document, 'sign_up_payment_success', {
                                    payment_response: payment_response,
                                    userData: {
                                        name: $('input[data-recurly="first_name"]').val() + ' ' + $('input[data-recurly="last_name"]').val(),
                                        email: $('input[data-recurly="email"]').val(),
                                        phone: $('input[data-recurly="phone"]').val()
                                    }
                                });
                                functions.setCookie('visitorIsMember', 'true', 99999);
                                functions.resetCart();
                                setTimeout(function(){
                                    location.href = '/welcome/';
                                }, 1500);
                            } else {
                                functions.cy_dispatchEvent(document, 'sign_up_payment_err', payment_response);
                                $('#membership-signup-payment-error').text(payment_response.message).show();
                            }
                        }).always(function(){
                            $submitBtn.removeClass('loading');
                        })
                    }
                }

                grecaptcha.ready(function() {
                    grecaptcha.execute('6LepsKEUAAAAAFZWtQMDdp_kVMRp7eLBDN4Bodbs', {action: 'purchase'}).then(function(token) {

                        functions.cy_dispatchEvent(document, 'recaptcha_complete');

                        recaptcha_token = token;

                        // Initiate token request, and ultimately, payment.
                        switch(jQuery('input[name="billing-payment_method"]:checked').val()) {
                            case 'creditcard':
                                recurly.token(elements, form, tokenHandler);
                            break;
                            case 'bankaccount':
                                recurly.bankAccount.token(form, tokenHandler);
                            break;
                        }

                    });;
                });
               
            })
        }
    });
})(jQuery);